import PropTypes from 'prop-types'
import styles from './MenuFiltros.module.css'

const MenuFiltrosBuscador = (props) => {
  let input

  return (
    <form
      id="formFiltrosBuscador"
      onSubmit={(event) => {
        event.preventDefault()
        props.onBuscar(input.value)
        input.value = ''
      }}
    >
      {props.titulo && <h2 className={styles.titulo_filtro_buscador}>{props.titulo}</h2>}
      <input
        className="buscarVentas"
        style={{ width: '1000px' }}
        rows="1"
        placeholder={props.placeholder}
        ref={(node) => (input = node)}
      />
    </form>
  )
}

MenuFiltrosBuscador.propTypes = {
  onBuscar: PropTypes.func.isRequired,
  titulo: PropTypes.string,
  placeholder: PropTypes.string
}

export default MenuFiltrosBuscador
